import { gql } from '@apollo/client/core';

export const typeDefs = gql`
  directive @client on FIELD
`;
